var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2048 2048",
    style: {
      enableBackground: "new 0 0 2048 2048"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFD8DD"
    },
    d: "M1303.413,1025.017V663.449c0-153.889-125.904-281.803-279.793-281.597 c-153.895,0.206-279.033,125.47-279.033,279.412v82.191c0,34.753-28.173,62.926-62.926,62.926h0 c-34.753,0-62.926-28.173-62.926-62.926v-82.191c0-54.682,10.724-107.763,31.873-157.766 c20.415-48.266,49.627-91.6,86.825-128.799c37.2-37.199,80.534-66.411,128.799-86.825C916.236,266.724,969.316,256,1023.999,256 c54.683,0,107.763,10.724,157.767,31.874c48.265,20.414,91.6,49.627,128.799,86.825c37.198,37.198,66.41,80.532,86.826,128.799 c21.15,50.003,31.874,103.082,31.874,157.766v363.752H1303.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7E07F"
    },
    d: "M1553.511,1792H494.489c-22.091,0-40-17.909-40-40V961.791c0-22.091,17.909-40,40-40h1059.022 c22.091,0,40,17.909,40,40V1752C1593.511,1774.091,1575.603,1792,1553.511,1792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBCD6D"
    },
    d: "M1077.454,1377.325v172.107H970.546v-172.107c-35.556-19.074-59.728-56.609-59.728-99.783 c0-62.511,50.671-113.182,113.182-113.182s113.182,50.671,113.182,113.182C1137.182,1320.715,1113.01,1358.251,1077.454,1377.325z "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c01d6563901f1331904cabdcf56a281d.svg";
export { ForwardRef as ReactComponent };